import { aktuelSide } from './navigation'

/**
 * Handoff fra embed-widgeten til den native flade — med vejen hjem indbygget.
 *
 * Widgeten bor på studiets EGEN hjemmeside. Hver gang et hold kræver noget
 * bundlen ikke kan levere (betaling, deltagernavne, medlemskab,
 * ansvarsfraskrivelse) sendes den besøgende over på vores flade. Uden et
 * returmål endte hun dér og skulle selv finde hjem igen.
 *
 * `/widget-retur` validerer adressen mod studiets godkendte widget-oprindelser
 * og gemmer den i en cookie. Derfor overlever returlinket HELE opholdet —
 * login, oprettelse, waiver-accept, betaling, kvittering — uanset hvor mange
 * sider kunden kommer igennem. En query-parameter ville være væk efter det
 * første NextAuth-redirect.
 *
 * ⚠️ `til`/`naeste` er en DELT kontrakt med apps/holdstyring lib/widget-retur-url.ts
 * og selve /widget-retur-ruten. Omdøb dem aldrig kun ét sted.
 */
export function handoffUrl(tenantBaseUrl: string, path: string): string {
  // Ingen window (SSR/prerender af en vært der server-renderer bundlen): fald
  // tilbage til det rene deeplink, præcis som før returbjælken fandtes.
  // aktuelSide(): i en Wix-iframe er det værtens side, ikke iframens filesusr-adresse.
  const retur = aktuelSide()
  if (!retur) return `${tenantBaseUrl}${path}`
  return (
    `${tenantBaseUrl}/widget-retur` +
    `?til=${encodeURIComponent(retur)}` +
    `&naeste=${encodeURIComponent(path)}`
  )
}

/**
 * Adressen widgeten står på lige nu, til brug som returmål.
 *
 * Den inline drop-in-betaling sender kunden DIREKTE til Stripe og kommer altså
 * ikke forbi handoffUrl()'s /widget-retur-hop. Uden et returmål med i den
 * anmodning landede kunden efter "afbryd betaling" på VORES flade med en
 * "gå til forsiden"-knap der pegede på vores eget tenant-site, ikke på den
 * hjemmeside hun kom fra. Serveren bygger Stripes success/cancel-URL gennem
 * /widget-retur med denne adresse, så returcookien er sat når hun kommer
 * tilbage fra betalingen.
 */
export function returMaal(): string | undefined {
  return aktuelSide() || undefined
}
